const transformer = function (origin, defs) {
  return {
    render: 'user',
    origin,
    value: origin,
    defs,
  }
}

export default transformer

// import { isArray, isPlainObject } from 'lodash-es'
// import { photoBgColor } from '@ow/utils'

// const renderUserInfo = function (origin) {
//   return (
//     <div className="flex items-center">
//       {origin.photo ? (
//         <img
//           className="rounded-full mr-2"
//           alt=""
//           src={origin.photo}
//           style={{ width: '24px', height: '24px' }}
//         />
//       ) : (
//         <div
//           className="rounded-full text-white flex justify-center items-center mr-2"
//           style={{
//             background: photoBgColor(origin.id),
//             width: '24px',
//             height: '24px',
//             border: '0.0625rem solid #fff',
//             boxShadow: '0 0 0.5rem 0 rgba(0,0,0,0.12)',
//           }}
//         >
//           {origin.name ? origin.name[origin.name.length - 1] : ''}
//         </div>
//       )}

//       {origin.name}
//     </div>
//   )
// }
// const transformer = function (origin) {
//   const ret = {
//     render: 'text',
//     origin,
//   }

//   if (isPlainObject(origin)) {
//     ret.value = renderUserInfo(origin)
//   }

//   if (isArray(origin)) {
//     ret.value = (
//       <div className="w-full flex">
//         {origin.map((val) => {
//           return renderUserInfo(val)
//         })}
//       </div>
//     )
//   }

//   return ret
// }

// export default transformer
